import { render, staticRenderFns } from "./questionAnswer.vue?vue&type=template&id=7bdeb94c&scoped=true&"
import script from "./questionAnswer.vue?vue&type=script&lang=js&"
export * from "./questionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./questionAnswer.vue?vue&type=style&index=0&id=7bdeb94c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdeb94c",
  null
  
)

export default component.exports